// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__ohQqi","body":"style__body__a5xNE","footer":"style__footer__bjww6"};